<script lang="ts">
export default {
  name: 'DialogTitle',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { DialogTitle } from 'reka-ui';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
}

const props = defineProps<Props>();

const titleClass = computed(() => cn('text-lg font-semibold leading-none tracking-tight', props.class));
</script>

<template>
  <DialogTitle :class="titleClass" v-bind="$attrs">
    <slot />
  </DialogTitle>
</template>
